/**
 * Idle session watchers — countdown 24 jam selalu jalan (ID/EN, light/dark).
 */
export default defineNuxtPlugin((nuxtApp) => {
  if (!import.meta.client) return;
  nuxtApp.hook('app:mounted', () => {
    const { startWatchers } = useIdleSession();
    startWatchers();
  });
});
